import { render, staticRenderFns } from "./AgencyMessageEmailSection.vue?vue&type=template&id=9dee5154&scoped=true"
import script from "./AgencyMessageEmailSection.vue?vue&type=script&lang=js"
export * from "./AgencyMessageEmailSection.vue?vue&type=script&lang=js"
import style0 from "./AgencyMessageEmailSection.vue?vue&type=style&index=0&id=9dee5154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dee5154",
  null
  
)

export default component.exports